import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=f0a1c2ea"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports